const EMPTY_EDITABLE_CONTENT = '<div></div>'

export function ensureEditableEmailBody (content) {
  if (!content) {
    return EMPTY_EDITABLE_CONTENT
  }

  const headerEndTag = '</email-header>'
  const footerStartTag = '<email-footer>'
  const headerEndIndex = content.lastIndexOf(headerEndTag)
  const bodyStartIndex = headerEndIndex === -1 ? 0 : headerEndIndex + headerEndTag.length
  const footerStartIndex = content.indexOf(footerStartTag, bodyStartIndex)
  const bodyEndIndex = footerStartIndex === -1 ? content.length : footerStartIndex

  if (content.slice(bodyStartIndex, bodyEndIndex).trim()) {
    return content
  }

  return `${content.slice(0, bodyStartIndex)}${EMPTY_EDITABLE_CONTENT}${content.slice(bodyEndIndex)}`
}
